<section class="chat-header primary-background-gradient">
  <div class="auto header-container">
    <div class="beta-badge">BETA</div>
    <h1>Ask Via</h1>
    <p>{{ subtitle }}</p>
  </div>

  @if (canExpand) {
  <!-- A11Y.1: icon only, so it needs a name (4.1.2). The name says what a
       press does now; no aria-pressed as well, or it would be said twice. -->
  <button type="button"
    class="expand-button"
    mat-icon-button
    [attr.aria-label]="isFullScreen ? 'Exit full screen' : 'Expand Via to full screen'"
    (click)="onToggleFullScreen()"
    matTooltipPosition="above"
    [matTooltip]="isFullScreen ? 'Shrink to Margin' : 'Full Screen'"
  >
    @if (isFullScreen) {
      <fa-icon [icon]="['far', 'compress']"></fa-icon>
    } @else {
      <fa-icon [icon]="['far', 'expand']"></fa-icon>
    }
  </button>
  }

  <button
    aria-label="Close Via"
    type="button"
    class="close-button"
    mat-icon-button
    matTooltip="Close Window"
    matTooltipPosition="above"
    (click)="close()"
  >
    <fa-icon [icon]="['fal', 'times']"></fa-icon>
  </button>
</section>
